module.exports = __webpack_public_path__ + "img/fron-05.f8f6c1be.jpg";